import { AutogenModelBookingNumberLookup, AutogenRowBookingNumberLookup } from "./autogen/AutogenModelBookingNumberLookup";

export class ModelBookingNumberLookup extends AutogenModelBookingNumberLookup<RowBookingNumberLookup> {
	constructor() {
		super(RowBookingNumberLookup);
	}
}

export class RowBookingNumberLookup extends AutogenRowBookingNumberLookup {
}